import axios from './index';

class OperationLocationApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.booleanFilter) {
      query += `is_active=${data.booleanFilter}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    let request = {
      name: data.name,
      display_order: data.display_order || 100,
      is_active: data.is_active,
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {
      name: data.name,
      display_order: data.display_order || 100,
      is_active: data.is_active,
    };
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };
}

let base = 'dashboard/operation-location';

export default OperationLocationApi;
